import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationMyVideosEmptyStateMobile(props) {
  return (
    <svg
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M96 0H0v96h96V0zM84 12v72H12V12h72z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.023 48.341L48.341 11.66 11.66 48.341 48.34 85.023l36.682-36.682zm-56.69 0L48.34 28.333 28.333 48.34zm20.842 19.175L68.35 48.34 49.175 29.167v38.349z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IllustrationMyVideosEmptyStateMobile;
